import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const shipmentResults = createSlice({
	name: 'shipmentResults',
	initialState,
	reducers: {
		addShipmentResult: (state, { payload }) => ({ ...state, ...payload }),
		removeShipmentResult: (state, { payload }) => {
			const newState = { ...state };
			delete newState[payload];
			return newState;
		},
		removeMultipleShipmentResults: (state, { payload }) => {
			const newState = { ...state };
			payload.forEach((id) => {
				delete newState[id];
			});
			return newState;
		}
	}
});

export const { addShipmentResult, removeShipmentResult, removeMultipleShipmentResults } = shipmentResults.actions;

export default shipmentResults.reducer;
